import { SliceCaseReducers } from '@reduxjs/toolkit/src/createSlice';
import { DatasourceUsersProps } from '../../../types/reduxTypes/datasourceUsers';

const createReducer = <T extends SliceCaseReducers<DatasourceUsersProps>>(reducer: T) => ({ ...reducer });

const reducers = createReducer({
  setDatasourceUsersData(state, action) {
    state.datasourceUsersData = action.payload;
  }
});

export default reducers;
